import { Component, ElementRef, EventEmitter, Output, ViewChild, OnInit, Input } from '@angular/core';

import { AuthService, ButtonLoader } from '../../../../core';
import { Cliente } from '../../cliente';
import { OrigemLancamentoCadastro, origemLancamentoCadastroSogivendas, origemLancamentoCadastroProspeccaoOutbound, isOrigemLancamentoCadastroProspeccaoOutbound } from '../../../../models/origem-lancamento-cadastro';
import { Origem } from '../../../common/origens/domain';
import { ClienteFormComponent } from '../form';

@Component({
    selector: 'sgt-cliente-form-modal',
    templateUrl: './cliente-form-modal.component.html',
    styleUrls: ['./cliente-form-modal.component.less']
})
export class ClienteFormModalComponent implements OnInit {
    title = 'Cadastro de Cliente';
    isRepresentante: boolean;

    elModal: any;
    isOpen = false;

    idCliente: number;
    editMode: boolean;
    origemCadastroCliente: OrigemLancamentoCadastro = null;
    origemCliente: Origem = null;
    cnpjCpfPessoa: string = null;

    // Defaults
    /** Tipo de pessoa padrão ao inserir um novo cliente */
    tipoPessoaDefault: number = null;

    // @Input() complentandoCadastro = false; // Se está completando o cadastro do cliente

    @ViewChild('form') form: ClienteFormComponent;
    @Output() afterInsert = new EventEmitter<Cliente>();
    @Output() afterEdit = new EventEmitter<Cliente>();
    @Output() afterCancel = new EventEmitter<any>();

    constructor(private el: ElementRef,
                private authService: AuthService) { }

    ngOnInit() {
        this.isRepresentante = this.authService.isRepresentante();

        this.create();
    }

    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                this.isOpen = true;
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                if (this.editMode) {
                    this.form?.edit(this.idCliente);
                } else {
                    if (isOrigemLancamentoCadastroProspeccaoOutbound(this.origemCadastroCliente?.id)) { // Insert pela Prospecção Outbound
                        this.form?.insertByProspeccaoOutbound(this.cnpjCpfPessoa);
                    } else { // Insert padrão
                        this.form?.insert(origemLancamentoCadastroSogivendas, this.tipoPessoaDefault);
                    }
                }
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                this.isOpen = false;
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                this.clear();
                e.stopPropagation();
            });
    }

    /** Abre modal para inserir um novo cliente */
    private insertAndOpen(origemCastroCliente: OrigemLancamentoCadastro, origemCliente: Origem = null, tipoPessoaDefault: number = null, cnpjCpfPessoa: string = null, title = 'Adicionando novo cliente') {
        this.title = title;
        this.origemCadastroCliente = origemCastroCliente;
        this.origemCliente = origemCliente;
        this.cnpjCpfPessoa = cnpjCpfPessoa;
        this.editMode = false;
        this.idCliente = null;
        // Defaults
        this.tipoPessoaDefault = tipoPessoaDefault;
        this.open();
    }

    /** Inserir um novo cliente */
    insert(origemCliente: Origem = null, tipoPessoaDefault: number = null, cnpjCpfPessoa: string = null, title = 'Adicionando novo cliente') {
        this.insertAndOpen(origemLancamentoCadastroSogivendas, origemCliente, tipoPessoaDefault, cnpjCpfPessoa, title);
    }

    /** Inserir um novo cliente pela Prospecção Outbound */
    insertByProspeccaoOutbound(origemCliente: Origem = null, tipoPessoaDefault: number = null, cnpjCpfPessoa: string = null, title = 'Adicionando novo cliente') {
        this.insertAndOpen(origemLancamentoCadastroProspeccaoOutbound, origemCliente, tipoPessoaDefault, cnpjCpfPessoa, title);
    }

    edit(idCliente: number, title = 'Editando cliente') {
        this.title = title;
        this.idCliente = idCliente;
        this.editMode = true;
        this.open();
    }

    private clear() {
        this.idCliente = null;
        this.origemCadastroCliente = null;
        this.origemCliente = null;
        this.cnpjCpfPessoa = null;
        this.form?.clear();
    }

    private open() {
        this.elModal.modal({keyboard: false, backdrop: 'static'});
    }

    private close() {
        this.elModal.modal('hide');
    }

    cancel() {
        this.afterCancel.emit();
        this.close();
    }

    save() {
        const btn = new ButtonLoader('#btnSaveClienteFormModal');
        btn.loading('Salvando');

        this.form?.save()
            .then(entity => {
                btn.reset();
                if (this.form?.editMode) {
                    this.afterEdit.emit(entity);
                } else {
                    this.afterInsert.emit(entity);
                }

                this.close();
            })
            .catch(() => {
                btn.reset();
            });
    }
}
